module.exports = __webpack_public_path__ + "static/media/text_title_en.1efa3f80.svg";